// "homepage": "https://clubecerto.github.io/new-dashboard",

export const coverURL = [
  'data:image/png;base64,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',
];

// GET QUANTIDADE DE UTILIZAÇÕES, ECONOMIA GERADA E CATEGORIAS MAIS UTILIZADAS - GERAL
//  COM POSIBILIDADE DE FILTRAR POR CPF VIA QUERY PARAMS
export const resume = {
  economiaGerada: '',
  quantidadeDeUtilizacoes: '',
  categoriasMaisUtilizadas: [
    {
      id: "1",
      nome: "Categoria 1",
      quantidadeDeUtilizacoes: "100",
    },
    {
      id: "2",
      nome: "Categoria 2",
      quantidadeDeUtilizacoes: "100",
    },
    {
      id: "3",
      nome: "Categoria 3",
      quantidadeDeUtilizacoes: "100",
    },
    {
      id: "4",
      nome: "Categoria 4",
      quantidadeDeUtilizacoes: "100",
    },
  ],
};

// GET 10 ESTABELECIMENTOS MAIS UTILIZADOS - GERAL
//  COM POSIBILIDADE DE FILTRAR POR CPF VIA QUERY PARAMS
export const mostUsedEstablishments = [
  {
    id: 45,
    nome: 'Estabelecimento 1',
    quantidadeDeUtilizacoes: '42',
    capa: coverURL,
  },
  {
    id: 136,
    nome: 'Estabelecimento 2',
    quantidadeDeUtilizacoes: '39',
    capa: coverURL,
  },
  {
    id: 1234,
    nome: 'Estabelecimento 3',
    quantidadeDeUtilizacoes: '38',
    capa: coverURL,
  },
  {
    id: 23452,
    nome: 'Estabelecimento 4',
    quantidadeDeUtilizacoes: '31',
    capa: coverURL,
  },
  {
    id: 23,
    nome: 'Estabelecimento 5',
    quantidadeDeUtilizacoes: '30',
    capa: coverURL,
  },
  {
    id: 141,
    nome: 'Estabelecimento 6',
    quantidadeDeUtilizacoes: '27',
    capa: coverURL,
  },
  {
    id: 867,
    nome: 'Estabelecimento 7',
    quantidadeDeUtilizacoes: '22',
    capa: coverURL,
  },
  {
    id: 4561,
    nome: 'Estabelecimento 8',
    quantidadeDeUtilizacoes: '19',
    capa: coverURL,
  },
  {
    id: 2342,
    nome: 'Estabelecimento 9',
    quantidadeDeUtilizacoes: '18',
    capa: coverURL,
  },
  {
    id: 111,
    nome: 'Estabelecimento 10',
    quantidadeDeUtilizacoes: '16',
    capa: coverURL,
  },
];

// GET 10 ESTABELECIMENTOS UTILIZADOS MAIS RECENTEMENTE - GERAL
//  COM POSIBILIDADE DE FILTRAR POR CPF VIA QUERY PARAMS
export const recentUsedEstablishments = [
  {
    id: 111,
    nome: 'Estabelecimento 10',
    ultimaUtilizacao: '2022-03-18 09-12-57',
    capa: coverURL,
  },
  {
    id: 2342,
    nome: 'Estabelecimento 9',
    ultimaUtilizacao: '2022-03-18 06-19-20',
    capa: coverURL,
  },
  {
    id: 4561,
    nome: 'Estabelecimento 8',
    ultimaUtilizacao: '2022-03-17 22-28-11',
    capa: coverURL,
  },
  {
    id: 867,
    nome: 'Estabelecimento 7',
    ultimaUtilizacao: '2022-03-17 21-45-11',
    capa: coverURL,
  },
  {
    id: 141,
    nome: 'Estabelecimento 6',
    ultimaUtilizacao: '2022-03-17 20-28-38',
    capa: coverURL,
  },
  {
    id: 23,
    nome: 'Estabelecimento 5',
    ultimaUtilizacao: '2022-03-17 18-22-22',
    capa: coverURL,
  },
  {
    id: 23452,
    nome: 'Estabelecimento 4',
    ultimaUtilizacao: '2022-03-17 18-15-01',
    capa: coverURL,
  },
  {
    id: 1234,
    nome: 'Estabelecimento 3',
    ultimaUtilizacao: '2022-03-17 15-28-11',
    capa: coverURL,
  },
  {
    id: 136,
    nome: 'Estabelecimento 2',
    ultimaUtilizacao: '2022-03-17 10-05-29',
    capa: coverURL,
  },
  {
    id: 45,
    nome: 'Estabelecimento 1',
    ultimaUtilizacao: '2022-03-16 23-47-42',
    capa: coverURL,
  },
];

// GET 10 ASSOCIADOS COM MAIOR ECONOMIA GERADA
export const discountRanking = [
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
  {
    id: '',
    cpf: '',
    economia: '',
  },
];

// GET QUANTIDADE (TOTAL ATIVOS E INATIVOS) E LISTAGEM (PAGINADO DE 50 EM 50) DE OS TODOS ASSOCIADOS
//  COM POSIBILIDADE DE FILTRAR POR CPF E ATIVOS/INATIVOS VIA QUERY PARAMS
export const allMembers = {
  amount: {
    ativos: 55123,
    inativos: 211,
  },
  members: [
    {
      id: "1",
      cpf: "12345678900",
      numeroDeUtilizacoes: "35",
      economia: "220.35",
      ultimoAcesso: "03-04-2022",
      ativo: "1",
    },
    {
      id: "2",
      cpf: "12345678901",
      numeroDeUtilizacoes: "65",
      economia: "472.91",
      ultimoAcesso: "03-02-2022",
      ativo: "1",
    },
    {
      id: "3",
      cpf: "12345678902",
      numeroDeUtilizacoes: "7",
      economia: "87.02",
      ultimoAcesso: "02-25-2022",
      ativo: "1",
    },
    {
      id: "4",
      cpf: "12345678903",
      numeroDeUtilizacoes: "22",
      economia: "110.95",
      ultimoAcesso: "01-17-2022",
      ativo: "1",
    },
    {
      id: "5",
      cpf: "12345678904",
      numeroDeUtilizacoes: "2",
      economia: "17.63",
      ultimoAcesso: "03-06-2022",
      ativo: "1",
    },
  ],
};

// GET DETALHES DE UM ASSOCIADO - POR CPF
export const member = {
  id: "1",
  cpf: '12345678900',
  nome: 'Associado da Silva',
  ultimoAcesso: "03-04-2022 21:08:42",
  numeroDeUtilizacoes: "35",
  economia: "220.35",
  estabelecimentosMaisUtilizados: [
    {
      id: 45,
      nome: 'Estabelecimento 1',
      quantidadeDeUtilizacoes: '42',
      capa: coverURL,
    },
    {
      id: 136,
      nome: 'Estabelecimento 2',
      quantidadeDeUtilizacoes: '39',
      capa: coverURL,
    },
    {
      id: 1234,
      nome: 'Estabelecimento 3',
      quantidadeDeUtilizacoes: '38',
      capa: coverURL,
    },
    {
      id: 23452,
      nome: 'Estabelecimento 4',
      quantidadeDeUtilizacoes: '31',
      capa: coverURL,
    },
    {
      id: 23,
      nome: 'Estabelecimento 5',
      quantidadeDeUtilizacoes: '30',
      capa: coverURL,
    },
    {
      id: 141,
      nome: 'Estabelecimento 6',
      quantidadeDeUtilizacoes: '27',
      capa: coverURL,
    },
    {
      id: 867,
      nome: 'Estabelecimento 7',
      quantidadeDeUtilizacoes: '22',
      capa: coverURL,
    },
    {
      id: 4561,
      nome: 'Estabelecimento 8',
      quantidadeDeUtilizacoes: '19',
      capa: coverURL,
    },
    {
      id: 2342,
      nome: 'Estabelecimento 9',
      quantidadeDeUtilizacoes: '18',
      capa: coverURL,
    },
    {
      id: 111,
      nome: 'Estabelecimento 10',
      quantidadeDeUtilizacoes: '16',
      capa: coverURL,
    },
  ],
  categoriasMaisUtilizadas: [
    {
      id: "3",
      nome: "Categoria 3",
      quantidadeDeUtilizacoes: "234",
    },
    {
      id: "2",
      nome: "Categoria 2",
      quantidadeDeUtilizacoes: "178",
    },
    {
      id: "1",
      nome: "Categoria 1",
      quantidadeDeUtilizacoes: "96",
    },
  ],
  ultimosEstabelecimentosUtilizados: [
    {
      id: 111,
      nome: 'Estabelecimento 10',
      ultimaUtilizacao: '2022-03-18 16-00-00',
      capa: coverURL,
    },
    {
      id: 2342,
      nome: 'Estabelecimento 9',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 4561,
      nome: 'Estabelecimento 8',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 867,
      nome: 'Estabelecimento 7',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 141,
      nome: 'Estabelecimento 6',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 23,
      nome: 'Estabelecimento 5',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 23452,
      nome: 'Estabelecimento 4',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 1234,
      nome: 'Estabelecimento 3',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 136,
      nome: 'Estabelecimento 2',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
    {
      id: 45,
      nome: 'Estabelecimento 1',
      ultimaUtilizacao: '2022-03-08 16-00-00',
      capa: coverURL,
    },
  ],
  pracaPrincipal: "Belo Horizonte",
  ativo: "1",
};

// POST PARA ATIVAR OU INATIVAR UM ASSOCIADO
//  RETORNA OS DETALHES DO PRÓPRIO ASSOCIADO, JÁ ATUALIZADO ATUALIZADO
export const memberUpdated = {
  id: "1",
  cpf: '12345678900',
  nome: 'Associado da Silva',
  ultimoAcesso: "03-04-2022 21:08:42",
  numeroDeUtilizacoes: "35",
  economia: "220.35",
  estabelecimentosMaisUtilizados: [
    {
      id: 4561,
      name: 'Estabelecimento 8',
      cover: coverURL,
      category: 'Categoria 10',
      isActive: "1",
    },
    {
      id: 2342,
      name: 'Estabelecimento 9',
      cover: coverURL,
      category: 'Categoria 14',
      isActive: "1",
    },
    {
      id: 111,
      name: 'Estabelecimento 10',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 45,
      name: 'Estabelecimento 11',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 136,
      name: 'Estabelecimento 12',
      cover: coverURL,
      category: 'Categoria 2',
      isActive: "1",
    },
    {
      id: 1234,
      name: 'Estabelecimento 13',
      cover: coverURL,
      category: 'Categoria 6',
      isActive: "1",
    },
    {
      id: 23452,
      name: 'Estabelecimento 14',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "0",
    },
    {
      id: 23,
      name: 'Estabelecimento 15',
      cover: coverURL,
      category: 'Categoria 5',
      isActive: "1",
    },
    {
      id: 141,
      name: 'Estabelecimento 16',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 867,
      name: 'Estabelecimento 17',
      cover: coverURL,
      category: 'Categoria 9',
      isActive: "1",
    },
  ],
  categoriasMaisUtilizadas: [
    {
      id: "3",
      nome: "Categoria 3",
      quantidadeDeUtilizacoes: "234",
    },
    {
      id: "2",
      nome: "Categoria 2",
      quantidadeDeUtilizacoes: "178",
    },
    {
      id: "1",
      nome: "Categoria 1",
      quantidadeDeUtilizacoes: "96",
    },
  ],
  pracaPrincipal: "Belo Horizonte",
  ativo: "1",
};

// GET QUANTIDADE (TOTAL) E LISTAGEM (PAGINADO DE 50 EM 50) DE TODAS AS TRANSAÇÕES
//  COM POSIBILIDADE DE FILTRAR POR CPF E PERÍODO (ex formato: de 2022-02-11 até 2022-03-25) VIA QUERY PARAMS
export const transactionsHistory = {
  amount: '80',
  history: [
    {
      datetime: "2022-03-07 22:06:11",
      cpf: "12345678900",
      interactionType: "compra",
      economy: "6.82",
      establishmentName: "Restaurante X",
      category: "alimentação"
    },
    {
      datetime: "2022-03-07 08:23:47",
      cpf: "54832196587",
      interactionType: "compra",
      economy: "2.89",
      establishmentName: "Supermercado Y",
      category: "alimentação"
    },
    {
      datetime: "2022-02-28 19:48:32",
      cpf: "95314785932",
      interactionType: "consulta",
      economy: null,
      establishmentName: "Cinema Z",
      category: "lazer"
    },
    {
      datetime: "2022-02-19 15:28:18",
      cpf: "65321798354",
      interactionType: "consulta",
      economy: null,
      establishmentName: "Farmácia S",
      category: "saúde"
    },
    {
      datetime: "2022-02-18 21:01:55",
      cpf: "35972146258",
      interactionType: "compra",
      economy: "17.92",
      establishmentName: "Loja de departamento R",
      category: "loja online"
    },
  ],
};

// GET DA LISTA DE CATEGORIAS
export const categoriesList = [
  {
    id: 1,
    name: "Categoria 1",
  },
  {
    id: 2,
    name: "Categoria 2",
  },
  {
    id: 3,
    name: "Categoria 3",
  },
];

// GET QUANTIDADE (TOTAL ATIVOS E INATIVOS) E LISTAGEM (PAGINADO DE 30 EM 30) DE OS TODOS ESTABELECIMENTOS
//  COM POSIBILIDADE DE FILTRAR POR CATEGORIA, PRIMEIRA LETRA DO NOME E ATIVOS/INATIVOS VIA QUERY PARAMS
export const allEstablishments = {
  amount: {
    ativos: 132,
    inativos: 17,
  },
  establishments: [
    {
      id: 136,
      name: 'Estabelecimento 2',
      cover: coverURL,
      category: 'Categoria 2',
      isActive: "1",
    },
    {
      id: 1234,
      name: 'Estabelecimento 3',
      cover: coverURL,
      category: 'Categoria 6',
      isActive: "1",
    },
    {
      id: 23452,
      name: 'Estabelecimento 4',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 141,
      name: 'Estabelecimento 6',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 867,
      name: 'Estabelecimento 7',
      cover: coverURL,
      category: 'Categoria 9',
      isActive: "1",
    },
    {
      id: 4561,
      name: 'Estabelecimento 8',
      cover: coverURL,
      category: 'Categoria 10',
      isActive: "1",
    },
    {
      id: 2342,
      name: 'Estabelecimento 9',
      cover: coverURL,
      category: 'Categoria 14',
      isActive: "1",
    },
    {
      id: 111,
      name: 'Estabelecimento 10',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 14,
      name: 'Estabelecimento 11',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 634,
      name: 'Estabelecimento 12',
      cover: coverURL,
      category: 'Categoria 2',
      isActive: "1",
    },
    {
      id: 3452,
      name: 'Estabelecimento 13',
      cover: coverURL,
      category: 'Categoria 6',
      isActive: "1",
    },
    {
      id: 22323,
      name: 'Estabelecimento 15',
      cover: coverURL,
      category: 'Categoria 5',
      isActive: "1",
    },
    {
      id: 978,
      name: 'Estabelecimento 16',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 76,
      name: 'Estabelecimento 17',
      cover: coverURL,
      category: 'Categoria 9',
      isActive: "1",
    },
    {
      id: 967,
      name: 'Estabelecimento 18',
      cover: coverURL,
      category: 'Categoria 10',
      isActive: "1",
    },
    {
      id: 2364567942,
      name: 'Estabelecimento 19',
      cover: coverURL,
      category: 'Categoria 14',
      isActive: "1",
    },
    {
      id: 99,
      name: 'Estabelecimento 20',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 44675,
      name: 'Estabelecimento 21',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 786,
      name: 'Estabelecimento 22',
      cover: coverURL,
      category: 'Categoria 2',
      isActive: "1",
    },
    {
      id: 467867,
      name: 'Estabelecimento 23',
      cover: coverURL,
      category: 'Categoria 6',
      isActive: "1",
    },
    {
      id: 6767,
      name: 'Estabelecimento 24',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 9898,
      name: 'Estabelecimento 25',
      cover: coverURL,
      category: 'Categoria 5',
      isActive: "1",
    },
    {
      id: 133341,
      name: 'Estabelecimento 26',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "1",
    },
    {
      id: 11111,
      name: 'Estabelecimento 27',
      cover: coverURL,
      category: 'Categoria 9',
      isActive: "1",
    },
    {
      id: 345311,
      name: 'Estabelecimento 28',
      cover: coverURL,
      category: 'Categoria 10',
      isActive: "1",
    },
    {
      id: 7614,
      name: 'Estabelecimento 30',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "1",
    },
    {
      id: 45,
      name: 'Estabelecimento 1',
      cover: coverURL,
      category: 'Categoria 3',
      isActive: "0",
    },
    {
      id: 23,
      name: 'Estabelecimento 5',
      cover: coverURL,
      category: 'Categoria 5',
      isActive: "0",
    },
    {
      id: 2346452,
      name: 'Estabelecimento 14',
      cover: coverURL,
      category: 'Categoria 1',
      isActive: "0",
    },
    {
      id: 23714542,
      name: 'Estabelecimento 29',
      cover: coverURL,
      category: 'Categoria 14',
      isActive: "0",
    },
  ],
};

// GET DETALHES DE UM ESTABELECIMENTO - POR ID DO ESTABELECIMENTO
export const establishment = {
  Codigo: "50",
  Nome: "Churrascaria Porcão",
  Marca: "https://clubecerto.com.br/images/parceiros/clube-50.jpg",
  Sobre: "Tradicional casa de churrasco de BH. Rodízio completo com mais de 30 tipos de cortes e buffet variado com saladas, pratos quentes, japonês, massas.",
  Exclusivo: "0",
  online: "1",
  Linksite: "https://www.extra.com.br/clubecerto",
  Voucher: "",
  CategoriaNome: "Gastronomia",
  Beneficios: [
    {
      desconto: "50% de desconto no rodízio almoço",
      regra: "Válido de terça a sexta. Benefício válido para o associado e até 3 acompanhantes."
    },
    {
      desconto: "R$50,00 de desconto no rodízio jantar",
      regra: "Válido de terça a sexta. Benefício válido para o associado e até 3 acompanhantes."
    },
    {
      desconto: "R$50,00 de desconto no rodízio no almoço e jantar aos sábados",
      regra: "Benefício válido para o associado e até 3 acompanhantes."
    },
  ],
  Ativo: "1",
  Carousel: "0",
};

// POST PARA ATIVAR/INATIVAR UM ESTABELECIMENTO
//  RETORNA OS DETALHES DO PRÓPRIO ESTABELECIMENTO ATUALIZADO
export const establishmentUpdated = {
  Codigo: "460",
  Nome: "Extra",
  Marca: "https://clubecerto.com.br/images/parceiros/clube-460.jpg",
  Sobre: "",
  Exclusivo: "0",
  online: "1",
  Linksite: "https://www.extra.com.br/clubecerto",
  Voucher: "CLUBECERTO",
  CategoriaNome: "Loja virtual",
  Beneficios: [
    {
      desconto: "Até 5% de desconto em todo o site",
      regra: "Válido apenas para a loja virtual. Desconto válido mediante uso do cupom. Desconto válido para produtos vendidos e entregue pela Extra. Desconto não válido para os produtos com selo Esquenta Black ou Black Friday. Desconto não se aplica em iPhone 13, e em toda a Linha PlayStation 4 e PlayStation 5."
    },
    {
      desconto: "Até 25% de desconto em seleção de produtos",
      regra: "Válido apenas para a loja virtual. Desconto válido direto pelo link. Oferta não acumulativa. Desconto válido para produtos vendidos e entregue pela Extra. Desconto não válido para os produtos com selo Esquenta Black ou Black Friday. Atenção: Produtos da Seleção (Página Inicial da Parceria) o cupom da parceria não poderá ser aplicado. Nessa seleção o desconto estará aplicado automaticamente."
    },
  ],
  Ativo: "1",
};

// GET TODOS OS ESTADOS
export const allStates = [
  {
    id: "1",
    nome: "Minas Gerais",
  },
  {
    id: "2",
    nome: "Rio de Janeiro",
  },
];

// GET TODAS AS CIDADES - FILTRADO POR ID DO ESTADO
export const allCitiesByStateId = [
  {
    id: "1",
    nome: "Belo Horizonte",
  },
  {
    id: "2",
    nome: "Contagem",
  },
];

// POST DE UM NOVO ASSOCIADO
//  EX ASSOCIADO: {
  //   nome: '',
  //   cpfCnpjMatricula: '',
  //   cartao: '',
  //   cortesia: '',
// };

// POST DE UM NOVO ESTABELECIMENTO
//  EX ESTABELECIMENTO: {
  // nome: '',
  // login: '',
  // categoria: '',
  // sobre: '',
  // tags: '',
  // regras: '',
  // telefone1: '',
  // telefone2: '',
  // delivery: '',
  // site: '',
  // instagram: '',
  // ordemDeExibicao: '',
  // aceitaCartaoFisicoVirtual: '',
  // quemPodeUtilizar: '',
  // destaque: '',
  // lojaVirtual: '',
  // latitude: '',
  // longitude: '',
  // endereco: '',
  // cidade: '',
  // estado: '',
  // tituloEndereco: '',
  // horarioDeFuncionamento: '',
  // QRCode: '',
  // cupom: '',
  // cupomDescricao: '',
  // link: '',
  // desconto: '',
  // regra: '',
  // capa: nnull,  << FILE
  // logo: null,  << FILE
// };
